import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Posts from '../views/Posts.vue'
import Projects from '../views/Projects.vue'
import Article from '../views/Article.vue'
import CV from '../views/CV.vue'
import About from '../views/About.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/experience',
    name: 'experience',
    component: About
  },
  {
    path: '/projects',
    name: 'projects',
    component: Projects
  },
  // {
  //   path: '/posts',
  //   name: 'posts',
  //   component: Posts
  // },
  // {
  //   path: '/posts/:id',
  //   name: 'article',
  //   component: Article
  // },
  {
    path: '/resume',
    name: 'CV',
    component: CV,
    props: {
      pdfUrl: 'resume_202507.pdf'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
